import React,{useEffect,useState} from "react";
import { Button, TextField, Card, Box, palette, Switch } from "@material-ui/core";

import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import InputLabel from "@material-ui/core/InputLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { spacing } from "@material-ui/system";
import AccountCircleIcon  from "@material-ui/icons/AccountCircle";
import ArrowBackRounded from "@material-ui/icons/ArrowBackRounded";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useStyles } from "../../styles/styles";
import coreStyles from "../../styles/core.css";
import {useHistory,Link } from "react-router-dom";
import logo from "../../logo.png";

import {useDispatch, useSelector} from 'react-redux';
import {RegisterAction} from '../../redux/actions/AuthActions';

import PhoneInput from 'react-phone-input-2';

import 'react-phone-input-2/lib/style.css'
import { NepaliDatePicker } from "nepali-datepicker-reactjs"
import "nepali-datepicker-reactjs/dist/index.css"
import NepaliDate from 'nepali-date-converter'
const styles = {
  root: {
    backgroundColor: 'transparent !important',
    boxShadow: 'none',
    paddingTop: '25px',
    color: '#FFFFFF'
  },
  datePickerClass: {
    marginTop: "20px",
   
  },
  customButton: {
    marginTop: "15px",
    marginBottom: "30px",
    backgroundColor: "#67a8e4",
    textTransform: "Capitalize",
    clear: "both",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "30px",
    paddingRight: "30px",

    "&:hover": {
      background: "#67a8e4",
    },
  },
   centerItem: {
    flex: "auto",
    top: "15%",
    position: "relative",

    marginBottom: "10%",
    marginTop: "10%",
  },
   cardItem: {
    paddingTop: "30px",
  },
  primary: {
    color: "#67a8e4",
  },
  customFail: {
    color: "#ef5350",
  },
   customSuccess: {
    color: "#4caf50",
  },
   last_name_wrapper: {
    marginLeft: "-15px!important",
    '@media (max-width: 500px)': {
      marginLeft: "0px!important",
    },
  },
  middle_name_wrapper:{
    '@media (max-width: 500px)': {
      marginLeft: "0px!important",
    },
  },
  first_name_wrapper: {
    marginLeft: "0px!important",
  },
  customSpanLabel: {
    width: "75%!important",
  },

  linkContainer: {
    marginBottom: "20px",
  },
  customClear: {
    position: "relative",
    top: "40%",
    clear: "both",
    color: "#404346",
    fontSize: "16px",
  },
  customLinkDark: {
    color: "#404346",
    textDecoration: "none",
  },
   roundIcon: {
    backgroundColor: "white",
    borderRadius: "50%",
    color: "#67a8e4",
  },
  customLink: {
    color: "#fff",
    textDecoration: "none",
  },
  
  switchRoot: {
    width: "50px!important",
    height: "24px!important",
    padding: "0px!important",
  },
  switchBase: {
    color: "#818181!important",
    padding: "1px!important",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#23bf58!important",
      },
    },
  },
  thumb: {
    color: "white!important",
    width: "20px!important",
    height: "20px!important",
    margin: "1px!important",
  },
  track: {
    borderRadius: "20px!important",
    backgroundColor: "#818181!important",
    opacity: "1 !important!important",
    "&:after, &:before": {
      color: "white!important",
      fontSize: "11px!important",
      position: "absolute!important",
      top: "6px!important",
    },
    "&:after": {
      content: "'Yes'",
      left: "8px!important",
    },
    "&:before": {
      content: "'No'",
      right: "7px!important",
    },
  },
  checked: {
    color: "#23bf58 !important",
    transform: "translateX(26px) !important",
  },
  verticalGap: {
    '@media (max-width: 500px)': {
      marginTop: "20px"
    },
  },
  notifyUser: {

  }
}; 


function RegisterComponent(props) {
  //const classes = useStyles();
  const {classes} = props;

  const dispatch = useDispatch();
  const history = useHistory();
  const authResponse = useSelector(state=>state.userAuth.authResponse);

  const [fields, setState] = useState({
    email: "",
    first_name: "",
    last_name: "",
    middle_name:"",
    date_of_birth:"",
    gender:"male",
    email: "",
    contact_no:"",
    password: "",
    password_confirmation: "",
    isCompany:false
  });
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [emailFlag, setEmailFlag] = useState(false);
  const [passwordFlag, setPasswordFlag] = useState(false);
  const [errorFlag, setErrorFlag] = useState(false)
  const [phoneError, setPhoneError] = useState(false);
  const [phoneErrorStatus, setPhoneErrorStatus] = useState(false);
  const [dobDateBS, setDobDateBS] = useState("");
  const handleInputChange_ = (value, name) => {
    //nepali to english date converter
    var nepaliDate = new NepaliDate(value)
    var englishDateObj = nepaliDate.getAD();
    var year = englishDateObj.year;
    var tempMonth = englishDateObj.month + 1;
    var month = parseInt(englishDateObj.month) > 9 ? tempMonth : "0" + tempMonth;
    var date = parseInt(englishDateObj.date) > 9 ? englishDateObj.date : "0" + englishDateObj.date;

   
    setState({
      ...fields,
      date_of_birth: year + "-" + month + "-" + date
    })

  }
  
  const handleFieldChange = e => {
  
    if(e.target.id==='password' || e.target.id==='password_confirmation'){
      setPasswordMatch(true);
      setPasswordFlag(false);
    }
    if(e.target.id==='email'){
      setPasswordMatch(true);
      setEmailFlag(false);
    }
    if (e.target.id === 'date_of_birth') {
      var nepaliDate = new NepaliDate(new Date(e.target.value))
      nepaliDate = nepaliDate.format('YYYY-MM-DD')
      
      setDobDateBS(nepaliDate);
    }
    
    e.target.id = e.target.name==="gender"?"gender":e.target.id;
      setState({
          ...fields,
          [e.target.id] : e.target.value
      })
  }
  const  handleFieldChangePhone = (value) => {
    if(fields['contact_no']!=value){
      setState({
        ...fields,changeStatus: true,
        'contact_no':value,
    })
  }
}
  const UserRegister = (e) => {
    e.preventDefault();
    const passwordMatch = checkPasswordMatch(fields.password, fields.password_confirmation);

    if(passwordMatch === true){
      setPasswordMatch(false);
      return;
    }

    if (fields.contact_no.length == 0) {
       setPhoneErrorStatus(true)
       setPhoneError("Phone number must not be empty and starts with 98 or 97");
      return true;
    }
    var reg = new RegExp('^9((7|8))[0-9]{8}$', 'i');
    if (!reg.test(fields.contact_no)) {
      setPhoneErrorStatus(true)
      setPhoneError("Phone number must be 10 digits and starts with 98 or 97");
      return false;
    }
    dispatch(RegisterAction(fields, history,'/user/login'));
    if(authResponse.success===false){
      setErrorFlag(true)
    }
    


    
  };
const handleChange = (event) => {
  setState({ ...fields, [event.target.id]: event.target.checked });
      };
  

const checkPasswordMatch = (password,password_confirmation) => {
 return  password !== password_confirmation ? true : false; 
}
  useEffect(() => {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().split('T')[0];


    setState({ ...fields, date_of_birth: localISOTime });
 
  },[]);
  return (
    <div>
      <div className={classes.centerItem} >
        
      <Grid container item xs={12} alignItems="center"
  justifyContent="center">
          <Grid item xs={12} sm={6}>
        <Card className={classes.cardItem}>
              <Box
                component="img"
                sx={{
                  height: 70,
                  width: 400,
                  minHeight: { xs: 40, md: 70 },
                  maxHeight: { xs: 40, md: 167 },
                  maxWidth: { xs: 233, md: 400 },
                  minWidth: { xs: 233, md: 400 },
                }}
                alt="DOED"
                src={logo}
              />
          <h2 >
          <b className={classes.primary}>
            Client Registration</b>
          </h2>
              <h4>
                <b className={classes.primary}>
                  Please sign up with the detail of authorized person from company.</b>
              </h4>
              {phoneErrorStatus &&
                <div className={classes.customFail} >{phoneError}</div>
              }
         {!passwordMatch && <div className={classes.customFail} >Passwords must be matched & atleast 8 charaters in length</div> }
              {(authResponse.success == false )?
            <div className={classes.customFail}>
                  { 
                    Object.keys(authResponse.message).map((errorKey)=>(
                      ["email_error", "password_error", "password_email_error"].includes(errorKey)?null:
                        authResponse.message[errorKey].map((errorValue, index) => (
                          <div key={index}> {errorValue}
                            <br />
                          </div>

                        ))
                    
                     
                    ))
                  }
        
            </div>:
            <div className={classes.customSuccess}>{authResponse.message}</div>
            }
          <form onSubmit={UserRegister}>
          <Grid container item xs={12}>
                  <Grid item xs={12} sm={4} className={classes.first_name_wrapper} sx={{ml:10 }} >
            <div>
                      <FormControl variant="outlined" className={classes.formControl}>
              <TextField
                type="text"
                
                required
                margin="normal"
                variant="outlined"
                label="First Name"
                id="first_name"
                value={fields.first_name}
                onChange={handleFieldChange}
                hidden
              />
              </FormControl>
            </div>
            </Grid>
                  <Grid item xs={12} sm={4} className={classes.middle_name_wrapper}>
            <FormControl variant="outlined" className={classes.formControl}>
            <div>
              <TextField
                type="text"
                
                margin="normal"
                variant="outlined"
                label="Middle Name"
                id="middle_name"
                value={fields.middle_name}
                onChange={handleFieldChange}
                hidden
              />
            </div>
            </FormControl>
            </Grid>
                  <Grid item xs={12} sm={4} className={classes.last_name_wrapper} >
            <FormControl variant="outlined" className={classes.formControl}>
            <div>
              <TextField
                id="last_name"
                type="text"
                
                required
                margin="normal"
                variant="outlined"
                label="Last Name"
                value={fields.last_name}
                onChange={handleFieldChange}
              />
            </div>
            </FormControl>
            </Grid>
                 
           
                    <Grid item xs={12} sm={3}>
                    <FormControl variant="outlined" className={classes.formControl}>
                   
                        
                      <TextField
                        id="date_of_birth"
                        name="date_of_birth"
                        type="date"
                        notched={true}
                        margin="normal"
                        required
                        variant="outlined"
                        label="Date of Birth in AD"
                        value={fields.date_of_birth}
                        onChange={handleFieldChange}
                          inputlabelprops={{
                          shrink: true,
                        }}
                        focused
                      />
                      </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={3} >
                        <FormControl variant="outlined" className={[classes.formControl, classes.datePickerClass].join("")} >
                          <InputLabel shrink>Date of Birth in BS*</InputLabel>
                          <NepaliDatePicker inputClassName="MuiInputBase-input MuiOutlinedInput-input"
                            className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl"
                            value={dobDateBS}
                            name="date_of_birth"
                            required
                            onChange={(event) => handleInputChange_(event, "date_of_birth")}
                            options={{ calenderLocale: "ne", valueLocale: "en" }} />


                        </FormControl>


                      </Grid>
                      
                      
                  <Grid item xs={12} sm={6} style={{ marginTop: "20px" }}>
            <FormControl variant="outlined" className={classes.formControl}>
                        <FormLabel style={{fontSize:"14px"}}>Gender*</FormLabel>
                        <RadioGroup
                          required
                          name="gender"
                          value={fields.gender}
                          onChange={handleFieldChange}
                          row
                        >
                          <FormControlLabel
                            required
                            key="male"
                            value="male"
                            control={<Radio size="small" />}
                            label="Male"
                          style={{ fontSize: "14px" }}
                          />
                          <FormControlLabel
                            key="female"
                            value="female"
                            control={<Radio size="small" />}
                            label="Female"
                          style={{ fontSize: "14px" }}
                          />
                          <FormControlLabel
                            key="other"
                            value="other"
                            control={<Radio size="small" />}
                            label="Other"
                          style={{ fontSize: "14px" }}
                          />
                        </RadioGroup>
                      </FormControl>
                    
                    </Grid>
                  <Grid item xs={12} sm={6} > 
            <div>
                  
            <FormControl variant="outlined" className={classes.formControl}>
            <PhoneInput
                      margin="normal"
                      country="np"
                      placeholder="9812345768"
                      name='contact_no'
                      specialLabel={'Phone Number'}
                      containerStyle={{marginTop:"16px",
                      marginBottom: "8px",
                      }}
                      
                      required
                      
                      inputStyle={{width:"auto",verticleAlign:"middle"}}
                      defaultErrorMessage="You must have 10 digit phone number starts with 98 or 97"
                      
  onlyCountries={['np']}
  value={fields.contact_no}
  onChange={(value, country, e, formattedValue)=>handleFieldChangePhone(value, country, e, formattedValue)}
  disableDropdown
  disableCountryCode
  inputProps={{
    required: true,
    autoFocus: true
  }}
  isValid={(value, country) => { 
    if(value.length==0){
      return true;
    }
    var reg = new RegExp('^9((7|8))[0-9]{8}$', 'i');
    if(!reg.test(value)){
      return false;
    }
    if(value.length==10){
    return true;
  }else{
    return false;
  }
}}
/>
</FormControl></div>
</Grid>
                  <Grid item xs={12} sm={6} > 
            <div>
              
            <FormControl variant="outlined" className={classes.formControl}>
              <TextField
                type="email"
                
                required
                margin="normal"
                variant="outlined"
                label="Email"
                id="email"
                value={fields.email}
                onChange={handleFieldChange}
              />
               </FormControl>
            </div>
           </Grid>
           
                  <Grid item xs={12} sm={6} > 
        <FormControl variant="outlined" className={classes.formControl}>
                <TextField
                  
                  label="Password"
                  type="password"
                  margin="normal"
                  variant="outlined"
                  required
                  id="password"
                  value={fields.password}
                  onChange={handleFieldChange}
                />
              </FormControl>
             </Grid>
                  <Grid item xs={12} sm={6} > 
        <FormControl variant="outlined" className={classes.formControl}>
                <TextField
                  
                  label="Confirm Password"
                  type="password"
                  required
                  margin="normal"
                  variant="outlined"
                  id="password_confirmation"
                  value={fields.password_confirmation}
                  onChange={handleFieldChange}
                />
              </FormControl>
              </Grid>
                  <Grid item xs={12} sm={6}> 
                    <FormControl variant="outlined" className={classes.formControl} style={{ "flexDirection": "row", "marginTop": "10px", "marginBottom": "10px" }}>
                      <span className={classes.customSpanLabel}>Incase if you are individual instead of company?</span>
                    <Switch
                      classes={{
                        root: classes.switchRoot,
                        switchBase: classes.switchBase,
                        thumb: classes.thumb,
                        track: classes.track,
                        checked: classes.checked
                      }}
                        id="isCompany"
                        checked={fields.isCompany}
                        onChange={handleChange}
                        name="isCompany"
                      inputProps={{ "aria-label": "secondary checkbox" }}
                    />
                  </FormControl>
             </Grid>
               
            
        </Grid>
              <div>
                <Button
                  type="submit"
                  className={[ classes.customButton ].join(' ')}
                  orientation="vertical"
                  aria-label="vertical contained button group"
                  variant="contained"
                  color="primary"
                  style={{clear:'both'}}
                >
                  <b>Register</b>
                </Button>
                <br />
                <div className={[classes.linkContainer, classes.customClear
].join(' ')} >
                  Already have an account? <Link to="/user/login" className={classes.customLinkDark}>Sign In</Link>
                </div>
              </div>

              <div className={classes.linkContainer}>
                  <Button startIcon={<ArrowBackRounded className={classes.roundIcon} />} className={[classes.customButton].join(' ')}> <Link to="/" className={classes.customLink}>Back To Home Page </Link></Button> 
              </div>

              <div></div>
           
           
          </form>
        </Card>
        </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default withStyles(styles)(RegisterComponent);
